import React from 'react';
import styled from 'styled-components';

const Notice = ({ text, color, width, marginTop, position }) => {
  let textColor = '#5d81ec';
  let containerColor = '#dfe6fb';
  if (color === 'red') {
    textColor = '#ff5c6c';
    containerColor = '#ffdee2';
  }
  let containerWidth = '946px';
  if (width) containerWidth = width;

  return (
    <Container
      textColor={textColor}
      containerColor={containerColor}
      containerWidth={containerWidth}
      marginTop={marginTop}
      position={position}
    >
      {text}
    </Container>
  )
};

const Container = styled.div`
  background-color: ${props => props.containerColor};
  color: ${props => props.textColor};
  font-size: 14px;
  width: ${props => props.containerWidth};
  margin-top:  ${props => props.marginTop};
  position: ${props => props.position};
  padding: 10px;
  border-radius: 4px;
  font-family: 'Karla', sans-serif;
`;

export default Notice;



// WEBPACK FOOTER //
// ./client/redesign/web/components/Notice/index.js